import React from 'react';
import '../styles/lodgifySearchBox.css';

const LodgifySearchBox =(props)=> {
    //const lang = props.lang;
    
    return (
        <div className='lofgifySearchBox'>
            <div 
                id="lodgify-search-bar"
                data-website-id="431368"
                data-language-code="en"
                data-search-page-url="https://bookings.lacroixdemillorit.com/en/all-rooms"
                data-dates-check-in-label="Arrival"
                data-dates-check-out-label="Departure"
                data-guests-counter-label="Guests"
                data-guests-input-singular-label="{{NumberOfGuests}} guest"
                data-guests-input-plural-label="{{NumberOfGuests}} guests"
                data-location-input-label="Location"
                data-search-button-label=""
                data-new-tab="true"
                data-version="stable"   
                >
            </div>
        </div>
    )
}

export default LodgifySearchBox;